import { InkindPageAPIModel } from '@gik/core/models/gik/InkindPage';

/**
 * Check if a user is the owner of the inkind page.
 */
export function isInkindPageOwner(inkindPage: InkindPageAPIModel, userId: string): boolean {
  return inkindPage?.owner?.userId === userId;
}

/**
 * Check if a user is an organizer of the inkind page.
 */
export function isInkindPageOrganizer(inkindPage: InkindPageAPIModel, userId: string): boolean {
  return inkindPage?.organizers?.findIndex(o => o.userId === userId) >= 0;
}

/**
 * Check if a user is the owner or an organizer of the inkind page (not explicitly with edit rights).
 */
export function isInkindPageOwnerOrOrganizer(inkindPage: InkindPageAPIModel, userId: string): boolean {
  return isInkindPageOwner(inkindPage, userId) || isInkindPageOrganizer(inkindPage, userId);
}

/**
 * Check if a user is the owner or an organizer of the inkind page explicitly with edit rights.
 */
export function canUserEditPage(inkindPage: InkindPageAPIModel, userId: string): boolean {
  return (
    isInkindPageOwner(inkindPage, userId) ||
    inkindPage?.organizers?.findIndex(o => o.userId === userId && o.canEdit) >= 0
  );
}

export function inkindPageOwnerIsRecipient(inkindPage: InkindPageAPIModel): boolean {
  return (
    inkindPage &&
    (inkindPage.owner.email === inkindPage.recipientEmail ||
      inkindPage.organizers.findIndex(organizer => organizer.email === inkindPage.recipientEmail) > -1)
  );
}

export function isUserFollowingPage(
  inkindPage: InkindPageAPIModel,
  userId: string,
  userPages: InkindPageAPIModel[]
): boolean {
  return userId && inkindPage && !!userPages?.find(page => page.routeId === inkindPage.routeId);
}
